import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthentificationService } from '../../providers/Global/authentification.service';
import { UserSettingsService } from '../../providers/Global/userSettings.service';
import { PersonalSettingsComponent } from '../personalsettings/personalSettings.component';
import { User } from '../../ressources/types/user';
import { Globals } from '../../ressources/variables/globals';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  version = Globals.version;

  initLoginSub;
  isLoggedInSub;
  userSub;
  permissionsSub;

  initLogin = false;
  isLoggedIn = false;
  user: User;

  permissions: Array<string>;

  /** Nombre d'items du menu "Voir +" accessibles à l'utilisateur */
  get moreMenuCount(): number {
    if (!this.permissions) return 0;
    return [
      this.permissions.includes('global_config') || this.permissions.includes('user_config'),
      this.permissions.includes('edit_winmedia_sql'),
      this.permissions.includes('edit_winmedia_spots'),
    ].filter(Boolean).length;
  }

  /** Item unique à afficher directement quand moreMenuCount === 1 */
  get singleMoreItem(): { label: string; route: string } | null {
    if (!this.permissions || this.moreMenuCount !== 1) return null;
    if (this.permissions.includes('global_config') || this.permissions.includes('user_config'))
      return { label: 'Configuration', route: '/admin' };
    if (this.permissions.includes('edit_winmedia_sql'))
      return { label: 'Edit Winmedia', route: '/editWinmedia' };
    if (this.permissions.includes('edit_winmedia_spots'))
      return { label: 'Spots', route: '/spots' };
    return null;
  }

  constructor(
    private authentificationService: AuthentificationService,
    private userSettingsService: UserSettingsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public router: Router
  ) {}

  ngOnInit() {
    this.initLoginSub = this.authentificationService.initLogin.subscribe(message => {
      this.initLogin = message;
      console.log('initLogin', this.initLogin);
    });
    this.isLoggedInSub = this.authentificationService.isLoggedIn.subscribe(message => {
      this.isLoggedIn = message;
      console.log('isLoggedIn', this.isLoggedIn);
    });
    this.userSub = this.authentificationService.user.subscribe(message => {
      this.user = message;
      console.log('user', this.user);
    });
    this.permissionsSub = this.authentificationService.permissions.subscribe(message => {
      this.permissions = message;
      console.log('permissions', this.permissions);
    });

    this.authentificationService.status()
      .then(res => console.log(res))
      .catch(err => console.log(err));
  }

  ngOnDestroy() {
    this.initLoginSub.unsubscribe();
    this.isLoggedInSub.unsubscribe();
    this.userSub.unsubscribe();
    this.permissionsSub.unsubscribe();
  }

  logout() {
    this.authentificationService.logout()
      .then(res => {
        console.log(res);
        this.router.navigate(['']).then(r => {
          console.log(r);
        });
      })
      .catch(err => {
        console.log(err);
        this.router.navigate(['']).then(r => {
          console.log(r);
        });
      });
  }

  openPersonalSettings() {
    Promise.all([
      this.userSettingsService.getStations(),
      this.userSettingsService.getCategories(),
      this.userSettingsService.getConfigTable()
    ]).then(([stations, categories, config]) => {
      const dialogRef = this.dialog.open(PersonalSettingsComponent, {
        width: '320px',
        data: {
          stations: stations || [],
          categories: categories || [],
          currentStations: config ? config.stations : null,
          currentCategorie: config ? config.categorie : null,
          currentPreferNickname: config ? !!config.prefer_nickname : false,
          hasNickname: this.user ? this.user.has_nickname : false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result || !result.action) return;

        const stations$ = result.action === 'reset' ? null : result.data.stations;
        const categorie$ = result.action === 'reset' ? null : result.data.categorie;
        const preferNickname$ = result.action === 'reset' ? false : !!result.data.preferNickname;

        this.userSettingsService.savePersonalSettings(stations$, categorie$, preferNickname$)
          .then(() => {
            this.authentificationService.refreshNameFromPreference(preferNickname$);
            const snackRef = this.snackBar.open(
              'Paramètres enregistrés',
              'Recharger',
              { duration: 6000 }
            );
            snackRef.onAction().subscribe(() => window.location.reload());
          })
          .catch(err => {
            console.error('Erreur lors de la sauvegarde des paramètres personnels', err);
            this.snackBar.open('Erreur lors de la sauvegarde', null, { duration: 3000 });
          });
      });
    }).catch(err => {
      console.error('Erreur lors du chargement des données', err);
      this.snackBar.open('Impossible de charger les paramètres', null, { duration: 3000 });
    });
  }

}
